import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { mapEnumToOptions } from '@app/shared/utils/map-enum-to-options.utils';
import { ChannelStatusEnum, ChannelStatusTranslations } from '../enum/channel-status-enum';
import { ChannelParams } from '../model/channel.model';

@Component({
  selector: 'flow-channel-filter-section',
  templateUrl: './channel-filter-section.component.html',
  styleUrls: ['./channel-filter-section.component.scss'],
})
export class ChannelFilterSectionComponent {
  @Input() isAdmin: boolean;
  @Output() onFilter = new EventEmitter();

  formGroup = this.fb.group({
    text: '',
    isActive: [],
  });

  channelStatusOptions = mapEnumToOptions(ChannelStatusTranslations);

  constructor(private fb: NonNullableFormBuilder) {}

  submit(): void {
    if (this.formGroup.pristine) {
      return;
    }

    this.emitParams();
  }

  private getChannelParams(): ChannelParams {
    const cleanedFormValues: ChannelParams = {};

    for (const key in this.formGroup.value) {
      let value = this.formGroup.value[key];
      if (key === 'isActive') {
        value = this.mapChannelStatusToBoolean(value);
      }

      cleanedFormValues[key] = value;
    }
    return cleanedFormValues;
  }

  clearAll(): void {
    this.formGroup.reset({
      text: '',
      isActive: [],
    });

    this.emitParams();
  }

  emitParams() {
    const params = this.getChannelParams();
    this.onFilter.emit(params);
  }

  mapChannelStatusToBoolean(statuses: number[]): boolean | number[] {
    const hasActive = statuses?.includes(ChannelStatusEnum.Active);
    const hasInactive = statuses?.includes(ChannelStatusEnum.Inactive);

    if (hasActive && hasInactive) {
      return [];
    } else if (hasActive) {
      return true;
    } else if (hasInactive) {
      return false;
    }

    return [];
  }
}
